
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chef/[chef-dynamic-url]",
      function () {
        return require("private-next-pages/chef/[chef-dynamic-url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chef/[chef-dynamic-url]"])
      });
    }
  